module.exports = require('./helpers/bundle-url').getBundleURL('kXH6J') + "logo.c5857b8b.svg";